import { useTranslation } from 'react-i18next';
import MonthlyReportView from '../MonthlyReportView';
import { useSession } from '@/hooks/useSession';

export default function VendorReportsPage() {
  const { t } = useTranslation();
  const { user } = useSession();
  const canExport = user?.role === 'vendor_operator';
  return (
    <MonthlyReportView
      title={t('vendor.reportsTitle')}
      queryKey={['vendor', 'reports', 'monthly']}
      reportUrl="/vendor/portal/reports/monthly"
      exportUrl={canExport ? '/vendor/portal/reports/monthly/export' : undefined}
      exportFilename="vendor-monthly.csv"
    />
  );
}
